import { LanguageResources } from '../../domain/language';
import { TypeWithKey } from '../../domain/shared';

export const getPasswordPolicieNameService = (
    title: string,
    langResources: LanguageResources
) => {
    const policies: TypeWithKey<string> = langResources['password.policies'];
    return policies[title];
};
